export enum MmOrderType {
  Buy = "buy",
  Sell = "sell",
}

export interface MmOrder {
  price: number;
  amount: number;
  myAmount: number;
  type: MmOrderType;
  count: number;
  total: number;
}
